<template>
  <div class="block-breadcrumbs" v-if="breadcrumbs.length">
    <div class="content" ref="scrollView">
      <a href="/" v-text="$t('home')" />
      <a
        v-for="item in breadcrumbs"
        :key="item.id"
        :href="item.path"
        v-text="item.name"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'block-breadcrumbs',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters({
      BREADCRUMBS: 'breadcrumbs/getBreadCrumbs'
    }),
    breadcrumbs() {
      return this.items.length ? this.items : this.BREADCRUMBS;
    },
  },
  mounted() {
    if (this.$refs.scrollView)
      this.$refs.scrollView.scrollLeft = 10000;
  },
  serverPrefetch () {
    if (this.items.length) return;
    return this.$store.dispatch('breadcrumbs/loadBreadCrumbs');
  }
}
</script>

<i18n src="./i18n.json"></i18n>

<style lang="scss">
.block-breadcrumbs {
  margin: 0 (-$containerGapMobile);
  height: 16px + 40px;
  overflow: hidden;
  position: relative;
  font-size: 12px;
  line-height: 16px;

  .content {
    padding: 20px $containerGapMobile 40px;
    white-space: nowrap;
    overflow-x: auto;
  }
  // Затухание
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: $containerGapMobile;
    pointer-events: none;
    background: linear-gradient(to right, $white, rgba($white, 0));
  }
  &::after {
    left: auto;
    right: 0;
    background: linear-gradient(to left, $white, rgba($white, 0));
  }
  a {
    color: $black;
    &:not(:first-child)::before {
      content: '•';
      display: inline;
      margin: 0 8px;
      color: $black;
    }
    &:last-child {
      color: $gray;
      pointer-events: none;
    }
  }
}

@include breakpoint("desktop") {
  .block-breadcrumbs {
    margin: 32px 0;
    height: auto;
    font-size: 14px;
    line-height: 20px;
    .content {
      padding: 0;
    }
    &::before,
    &::after {
      display: none;
    }
  }
}
</style>
